import React from "react";
import { render, hydrate } from "react-dom";

import { Root } from "components/Root";

import { ShortcutListener } from "./utils/ShortcutListener";
import { Automation } from "./utils/Automation";
import { painter } from "./evergis/painter";
import { map } from "./evergis/map";

import "./i18n/config";
import "./assets/main.css";

let isInitialRender = true;

const targetNode = document.getElementById("app");

function renderApp(Component: React.ComponentType, node: HTMLElement) {
  if (isInitialRender && targetNode.hasChildNodes() && typeof hydrate === "function") {
    hydrate(<Component />, node);
    isInitialRender = false;
  } else {
    render(<Component />, node);
  }
}

renderApp(Root, targetNode);

const automation = new Automation(map, painter);

new ShortcutListener([
  {
    shortcut: ["Control", "e"],
    listener: () => {
      const view = automation.getView();

      console.info(`Current bbox: ${JSON.stringify(view, null, 2)}`, view);
    },
  },
]);
